import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import "./i18n/i18n";

import "react-modal-video/scss/modal-video.scss";
import "./css/style.css";

const stripePromise = loadStripe(
  "pk_test_51PZXFhRvavSHZVmWwiC7JFMPHth5NcY6xhcuFwQcKGBflKRvUfLn0YzcZub8RVuGhwMCMWGIHe97Qp4rtXYZfxUf00FqCFz2W6"
);

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <Elements stripe={stripePromise}>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </Elements>
);

serviceWorker.unregister();
